var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 25,
    viewBox: "0 0 44 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9357 0.817609L32.9819 6.86375C33.4562 7.33804 33.4562 8.1073 32.9819 8.58158L26.9357 14.6237C26.4614 15.098 25.6922 15.098 25.218 14.6237L19.1718 8.58158C18.6975 8.1073 18.6975 7.33804 19.1718 6.86375L25.218 0.817609C25.457 0.582457 25.7719 0.462891 26.0788 0.462891C26.3857 0.462891 26.6966 0.582457 26.9357 0.817609ZM14.939 7.84819L10.8618 3.77092C10.6266 3.53577 10.3118 3.4162 10.0009 3.4162C9.68998 3.4162 9.37911 3.53577 9.13997 3.77092L5.06272 7.84819C4.58843 8.32247 4.58843 9.09173 5.06272 9.56601L9.13997 13.6432C9.61432 14.1175 10.3835 14.1175 10.8578 13.6432L14.9351 9.56601C15.4094 9.09173 15.4094 8.32247 14.9351 7.84819H14.939ZM36.2262 9.38263L42.9978 16.1542H42.9938C43.468 16.6285 43.468 17.3977 42.9938 17.872L36.2222 24.6436C35.7479 25.1178 34.9787 25.1178 34.5044 24.6436L27.7328 17.872C27.2586 17.3977 27.2586 16.6285 27.7328 16.1542L34.5044 9.38263C34.7435 9.14749 35.0544 9.02795 35.3653 9.02795C35.6762 9.02795 35.991 9.14355 36.2262 9.38263ZM18.4106 10.1798C18.1754 9.9446 17.8605 9.82506 17.5496 9.82506C17.2387 9.82506 16.9279 9.9446 16.6887 10.1798L11.4795 15.3929C11.0053 15.8672 11.0053 16.6365 11.4795 17.1108L16.6887 22.3199C17.163 22.7942 17.9323 22.7942 18.4065 22.3199L23.6197 17.1108C24.094 16.6365 24.094 15.8672 23.6197 15.3929L18.4065 10.1798H18.4106ZM4.64822 11.4871C4.41307 11.2519 4.0982 11.1324 3.78733 11.1324C3.47645 11.1324 3.16557 11.2519 2.92643 11.4871L0.355716 14.0618C-0.118572 14.5361 -0.118572 15.3053 0.355716 15.7796L2.93042 18.3543C3.40471 18.8286 4.17393 18.8286 4.64822 18.3543L7.22293 15.7796C7.69721 15.3053 7.69721 14.5361 7.22293 14.0618L4.64822 11.4871Z",
    fill: "url(#paint0_linear_53_444)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_444",
    x1: 3.87827e-9,
    y1: 13,
    x2: 43,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7717F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB665F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.94bc6884fde8d734425a7f08c4a59f8f.svg";
export { ForwardRef as ReactComponent };